import { render } from "./ninePage.vue?vue&type=template&id=6c3a4d5d&scoped=true"
import script from "./ninePage.vue?vue&type=script&lang=js"
export * from "./ninePage.vue?vue&type=script&lang=js"

import "./ninePage.vue?vue&type=style&index=0&id=6c3a4d5d&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3a4d5d"]])

export default __exports__